(function () {
    function hydrateHomeContentSlots() {
        var source = document.getElementById('dewa-home-action-links-source');
        var target = document.querySelector('[data-dewa-home-action-links]');
        var titleSource = document.querySelector('[data-dewa-home-hero-title]');
        var titleTarget = document.querySelector('[data-dewa-home-hero-title-target]');
        var subtitleSource = document.querySelector('[data-dewa-home-hero-subtitle]');
        var subtitleTarget = document.querySelector('[data-dewa-home-hero-subtitle-target]');

        if (titleSource && titleTarget) {
            titleTarget.textContent = titleSource.textContent.trim();
            titleSource.remove();
        }

        if (subtitleSource && subtitleTarget) {
            subtitleTarget.textContent = subtitleSource.textContent.trim();
            subtitleTarget.hidden = false;
            subtitleSource.remove();
        }

        if (!source || !target) {
            return;
        }

        while (source.firstChild) {
            target.appendChild(source.firstChild);
        }

        source.remove();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hydrateHomeContentSlots, {once: true});
    } else {
        hydrateHomeContentSlots();
    }
}());
